import { PureComponent } from "react"
import React from 'react';

import Editor from "@monaco-editor/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import * as monaco from "monaco-editor"
import "../dashboard/course.css"
import { CodeExecutorWebsocketHandler, applySelectionsFromMonacoSelection, getHashCode, getHighlightIndicesforRange, getHtmlCodeElementDoc,
     getRandomString, promReduxConnect, updateMonacoDecorationsFromTextHighlights } from "./utils";
import { reduxStateUpdateCodeRunOutput } from "../../store/common.reducer";

export const CODE_EVENT_TYPE_TEXT = "text"
export const CODE_EVENT_TYPE_SELECTION = "selection"
export const CODE_EVENT_TYPE_CURSOR = "cursor"
export const CODE_EVENT_TYPE_INIT = "init"


class PromCodeEditorComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            editedCodeTexts: {},
        }
        this.monacoRef = React.createRef()
        this.monacoEditor = React.createRef()
    }

    componentDidMount = () => {
        document.addEventListener("keydown", this.onKeydown);
    }
    
    componentDidUpdate = (prevProps) => {
        const { editorId, initialCodeText, highlightBlocks,
            readOnly } = this.props
        if (this.props.editorId !== prevProps.editorId) {
            let isEditTextCleared = false
            const newEditedCodeTexts = {...this.state.editedCodeTexts}
            Object.keys(this.state.editedCodeTexts || {}).forEach(eId => {
                if (eId !== this.props.editorId) {
                    isEditTextCleared = true
                    newEditedCodeTexts[eId] = null
                }
            })
            if (isEditTextCleared) {
                this.setState({editedCodeTexts: newEditedCodeTexts})
            }
        }
        
        if (this.monacoEditor?.updateOptions && readOnly !== prevProps.readOnly) {
            this.monacoEditor.updateOptions({ readOnly: readOnly })
        }

        if (editorId !== prevProps.editorId || 
            highlightBlocks !== prevProps.highlightBlocks || 
                initialCodeText !== prevProps.initialCodeText
            ) {
            this.setState({runId: null})
        }

        if (editorId !== prevProps.editorId || 
            (highlightBlocks !== prevProps.highlightBlocks &&
                JSON.stringify(highlightBlocks) !== JSON.stringify(prevProps.highlightBlocks)) || (
                initialCodeText !== prevProps.initialCodeText && initialCodeText !== this.getCurrentEditorText()
            )) {
            this.updateEditor()
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeydown);
    }

    componentWillUpdate(nextProps, nextState) {
        const stateKeys = new Set();
        const propsKeys = new Set();
        Object.keys(this.props).forEach(key => propsKeys.add(key));
        Object.keys(nextProps).forEach(key => propsKeys.add(key));
        Object.keys(this.state || {}).forEach(key => stateKeys.add(key));
        Object.keys(nextState || {}).forEach(key => stateKeys.add(key));

        const getDiff = (keys, object1, object2) => {
            const diffValues = [];
            const keysArray = [...keys];
            keysArray.filter(key => object1[key] !== object2[key]).forEach(key => 
                diffValues.push([key, object1[key], object2[key]]));
            return [...diffValues];
        };

        console.log(getDiff(propsKeys, this.props, nextProps),
            getDiff(stateKeys, this.state || {}, nextState || {}));
    }

    updateEditor = () => {
        if (!this.monacoEditor || !this.monacoEditor.setValue) {
            return
        }

        this.monacoEditor.setValue(this.getCurrentEditorText())
        this.updateDecorations()
    }

    updateDecorations = () => {
        updateMonacoDecorationsFromTextHighlights(
            this.monacoEditor, this.props.highlightBlocks, 
            this.getCurrentEditorText(), this.state.editedCodeTexts?.[this.props.editorId])
    }

    getCurrentEditorText = () => {
        const { initialCodeText, savedCodeText } = this.props
        const { editedCodeTexts } = this.state
        return editedCodeTexts?.[this.props.editorId] || savedCodeText || initialCodeText || ""
    }

    onEditorChange = (editorText, event) => {
        const { initialCodeText, editorId, editedCodeTexts } = this.props
        this.setState({editedCodeTexts: {
            ...editedCodeTexts,
            [editorId]: initialCodeText === editorText ? null: editorText
        }}, () => {
            this.updateDecorations()
        })
        if (this.props.onEditorTextChange) {
            this.props.onEditorTextChange(editorText)
        }
    }

    onEditorMount = (editor, monaco) => {
        this.monacoEditor = editor
        this.monacoEditor.updateOptions({
            minimap: {
                enabled: false
            },
            wordWrap: "on",
            readOnly: false,
            contextmenu: this.props.allowCodeCopyPaste === true
        })
        this.monacoEditor.onDidChangeCursorSelection(this.onDidChangeCursorSelection)
        // this.monacoEditor.onDidChangeCursorPosition(this.onDidChangeCursorPosition)
        // this.monacoEditor.onDidChangeModelContent(this.onDidChangeModelContent)
        this.updateEditor()
    }

    onDidChangeCursorSelection = (event) => {
        applySelectionsFromMonacoSelection(
            this.monacoEditor.getSelections(), this.getCurrentEditorText(), this.props.onSelectionChanged)
    }

    onKeydown = (event) => {
        const { allowCodeCopyPaste } = this.props;
        const key = event.key.toLowerCase();
        if (allowCodeCopyPaste !== true && event.ctrlKey && key === 'v') {
            // event.preventDefault();
        }
    }

    render = () => {
        const { allowCodeCopyPaste, isExerciseEditor, language} = this.props
        
        const currentEditorText = this.getCurrentEditorText()
        if (currentEditorText === null) {
            return null
        }
        
        return (<div style={{height: "100%", overflow:"hidden",paddingRight: isExerciseEditor ? "0.5rem":"0rem"}}>
            <Editor
                height={"100%" }
                width={isExerciseEditor?"100%":"97%"}
                defaultLanguage={language || "python"}
                allowCodeCopyPaste={allowCodeCopyPaste}
                onChange={this.onEditorChange}
                onMount={this.onEditorMount}
            />
        </div>)
    }
}

export const PromCodeEditor = promReduxConnect(PromCodeEditorComponent);